import { CompanyAPI } from '@api';

const getAllTerms = async () => CompanyAPI.getAllTerms()
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getAllTerms };
